import InnerComponent from '@Components/Sales/CreditNote/CreditNoteForm';
import orgContainer from '@Components/AppContainer';

const UpdateCreditNote = () => ((orgContainer(InnerComponent)));
export default UpdateCreditNote;
